import type { RevisionFileMatch } from '../../../../../hooks/api/revisions/useFileMatchesForRevision';

export type HighlightRange = {
  from: number;
  to: number;
};

/**
 * Parses match sources (strings of the form "start-end", where start and end are
 * absolute character offsets into the file) into highlight ranges for the CodeViewer.
 * Invalid or empty ranges are dropped.
 */
export function parseHighlightSources(sources: RevisionFileMatch['sources']): HighlightRange[] {
  return (sources || []).flatMap((source: string) => {
    if (!/^\d+-\d+$/.test(source)) {
      return [];
    }
    const [start, end] = source.split('-');
    const from = Number(start);
    const to = Number(end);
    return to > from ? [{ from, to }] : [];
  });
}
